class LoadMoreButton extends HTMLElement {
  constructor() {
    super();

    /** @type HTMLElement */
    this.loadMoreButtonEl = this.querySelector("a");
    this.arrowDownIconEl =
      this.loadMoreButtonEl.querySelector(".icon-arrow-down");
    this.loadingSpinnerIconEl =
      this.loadMoreButtonEl.querySelector(".icon-loader");

    this.loadMoreButtonEl.addEventListener("click", (e) => {
      e.preventDefault();
      this.loadNextPage();
    });
  }

  async loadNextPage() {
    const productGridEl = document.querySelector("#product-grid");
    const url = this.loadMoreButtonEl.getAttribute("href");

    this.arrowDownIconEl.style.display = "none";
    this.loadingSpinnerIconEl.style.display = "block";

    const res = await fetch(url, {
      method: "GET",
    });
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;

    const newProductGridEl = html.querySelector("#product-grid");
    productGridEl.insertAdjacentHTML("beforeend", newProductGridEl.innerHTML);

    const newButtonEl = html.querySelector("load-more-button a");

    if (!newButtonEl) {
      html.remove();
      this.remove();
      return;
    }

    const newButtonUrl = newButtonEl.getAttribute("href");
    this.loadMoreButtonEl.setAttribute("href", newButtonUrl);

    this.arrowDownIconEl.style.display = "block";
    this.loadingSpinnerIconEl.style.display = "none";

    // reset trustpilot
    /*const productCardEls = document.querySelectorAll(".product-card-wrapper");
    productCardEls.forEach((productCardEl) => {
      const trustpilotEl = productCardEl.querySelector(".trustpilot-widget");
      window.Trustpilot.loadFromElement(trustpilotEl);
    });*/

    html.remove();
  }
}

customElements.define("load-more-button", LoadMoreButton);
